var MessageItem = /** @class */ (function () {
    /** 构造函数 */
    function MessageItem(type, method) {
        this.type = type;
        this.method = method;
    }
    return MessageItem;
}());
var Message = /** @class */ (function () {
    function Message(thisObj) {
        var _this = this;
        /** 注册项列表 */
        this.registerList = [];
        /**
         * 获取注册列表的索引
         * @param type 消息类型
         * @param method 注册的代理函数
         */
        this.getIndex = function (type, method) {
            for (var i = 0; i < _this.registerList.length; i++) {
                if (_this.registerList[i].method === method && _this.registerList[i].type === type) {
                    return i;
                }
            }
            return -1;
        };
        if (thisObj) {
            this.thisObj = thisObj;
        }
        else {
            this.thisObj = this;
        }
    }
    /** 创建消息类型 */
    Message.createType = function (name) {
        return name + "@@" + Message.typeId++;
    };
    /**
     * 发送消息
     * @param event 消息
     */
    Message.prototype.send = function (event) {
        var _this = this;
        this.registerList.forEach(function (item) {
            if (event.type === item.type) {
                event.target = _this.thisObj;
                item.method(event);
            }
        });
    };
    /**
     * 注册消息
     * @param type 消息类型
     * @param method 注册的代理函数
     */
    Message.prototype.on = function (type, method) {
        if (this.getIndex(type, method) === -1) {
            this.registerList.push(new MessageItem(type, method));
        }
    };
    /** 批量注册 */
    Message.prototype.onBatch = function (list) {
        var _this = this;
        list.forEach(function (value) {
            _this.on.apply(_this, value);
        });
    };
    /**
     * 注销消息
     * @param type 消息类型
     * @param method 注册的代理函数
     */
    Message.prototype.off = function (type, method) {
        var index = this.getIndex(type, method);
        if (index >= 0) {
            this.registerList.splice(index, 1);
        }
    };
    /** 批量注册 */
    Message.prototype.offBatch = function (list) {
        var _this = this;
        list.forEach(function (value) {
            _this.off.apply(_this, value);
        });
    };
    /** 注销消息（所有）(弃用) */
    Message.prototype.offAll = function () {
        this.registerList = [];
    };
    Message.typeId = 0;
    return Message;
}());
export default Message;



//////////////////
// WEBPACK FOOTER
// ./node_modules/grey-message/Message/index.js
// module id = 1348
// module chunks = 0